import { createApp } from 'vue';
import M4bToOggConverter from '@/Components/M4bToOggConverter.vue';
import '@styles/app.css';

createApp(M4bToOggConverter).mount('#m4b-to-ogg-converter');
